/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IIntraOPChart } from 'app/shared/model/intra-op-chart.model';
import { IPostOPRecoveryRecord } from 'app/shared/model/post-op-recovery-record.model';
import { BloodProducts } from 'app/shared/model/enumerations/blood-products.model';

export interface IProcedureBloodProducts {
  id?: string;
  type?: keyof typeof BloodProducts | null;
  timeAdministered?: number | null;
  doseAdministered?: string | null;
  notes?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  intraOPChart?: IIntraOPChart;
  recoveryRecord?: IPostOPRecoveryRecord;
}

export const defaultValue: Readonly<IProcedureBloodProducts> = {
  active: false,
};
